var _path, _path2, _circle, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvertencia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 76,
    viewBox: "0 0 86 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2279 4.60701C40.2348 1.13101 45.252 1.13099 47.2589 4.607L82.7805 66.1323C84.7874 69.6083 82.2788 73.9533 78.2651 73.9533H7.2218C3.20805 73.9533 0.699449 69.6083 2.70632 66.1323L38.2279 4.60701Z",
    fill: "#FFF6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1947 24.9883L47.2722 4.58357C45.2534 1.12843 40.2558 1.14142 38.2549 4.60701L2.70632 66.179C0.699449 69.655 3.20805 74 7.2218 74H78.2651C82.2788 74 84.7874 69.655 82.7805 66.179L69.2341 42.716",
    stroke: "#FFA825",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5529,
    cy: 57.0734,
    r: 1.96855,
    transform: "rotate(-180 42.5529 57.0734)",
    fill: "#FFA825"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.5215,
    y: 50.6284,
    width: 3.93711,
    height: 20.473,
    rx: 1.96855,
    transform: "rotate(-180 44.5215 50.6284)",
    fill: "#FFA825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertencia);
export default __webpack_public_path__ + "static/media/Advertencia.7615c729e88b0fc2e0256dc4e9f99ed9.svg";
export { ForwardRef as ReactComponent };